// extracted by mini-css-extract-plugin
export var text = "_7w-0";